var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperienceRam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 4.66732H13.9998V11.334H12.6665V10.0007H11.3332V11.334H9.99984V10.0007H8.6665V11.334H7.33317V10.0007H5.99984V11.334H4.6665V10.0007H3.33317V11.334H1.99984V4.66732ZM1.33317 3.33398C1.15636 3.33398 0.98679 3.40422 0.861766 3.52925C0.736742 3.65427 0.666504 3.82384 0.666504 4.00065V12.0007C0.666504 12.1775 0.736742 12.347 0.861766 12.4721C0.98679 12.5971 1.15636 12.6673 1.33317 12.6673H14.6665C14.8433 12.6673 15.0129 12.5971 15.1379 12.4721C15.2629 12.347 15.3332 12.1775 15.3332 12.0007V4.00065C15.3332 3.82384 15.2629 3.65427 15.1379 3.52925C15.0129 3.40422 14.8433 3.33398 14.6665 3.33398H1.33317ZM7.33317 6.00065H3.33317V8.00065H7.33317V6.00065ZM8.6665 6.00065H12.6665V8.00065H8.6665V6.00065Z",
    fill: "#EE2B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceRam);
export default __webpack_public_path__ + "static/media/experience-ram.bd8604c75df235284049a5ea8fcd925b.svg";
export { ForwardRef as ReactComponent };